// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GaVGX","toggle":"styles_toggle__2Hn6R","preview":"styles_preview__tdAGO"};